import React, { useCallback, useState } from "react";
import { BagStep } from "./pda/PdaDispatchDetail";

/**
 * Test-only harness for validating the BagStep capture-input behaviour.
 * Route: /test/pda-bag-step (no auth). Exposes captured barcodes on
 * window.__bagBarcodes__ so Playwright can inspect them.
 */
export default function PdaBagStepTestHarness() {
  const [barcodes, setBarcodes] = useState([]);

  const onBagBarcode = useCallback((code) => {
    setBarcodes((prev) => {
      const next = [...prev, code];
      window.__bagBarcodes__ = next;
      return next;
    });
  }, []);

  if (typeof window !== "undefined") {
    window.__bagBarcodes__ = window.__bagBarcodes__ || [];
  }

  const packed = [
    { id: "b1", bundle_no: 1, barcode: "BAG-0001", status: "packed", items: [{ product_name: "Towel", quantity: 5 }] },
    { id: "b2", bundle_no: 2, barcode: "BAG-0002", status: "packed", items: [{ product_name: "Sheet", quantity: 3 }] },
  ];

  return (
    <div style={{ padding: 20, fontFamily: "monospace", maxWidth: 480 }}>
      <h1 data-testid="harness-title">Bag Step Harness</h1>
      <BagStep
        order={{ id: "order-1" }}
        packed={packed}
        onManualBagTick={() => {}}
        onUndoBag={() => {}}
        onBagBarcode={onBagBarcode}
      />
      <pre data-testid="captured-bag-barcodes">{JSON.stringify(barcodes)}</pre>
      <button
        data-testid="clear-bag-barcodes"
        onClick={() => {
          setBarcodes([]);
          window.__bagBarcodes__ = [];
        }}
      >
        clear
      </button>
    </div>
  );
}
